(function (window) {
  'use strict';

  if (window.SupportFormUpload) return;

  var MB = 1024 * 1024;
  var STYLE_ID = 'support-form-upload-styles';

  function t(key, vars) {
    var shared = (window.SupportFormI18n && window.SupportFormI18n.shared) || {};
    var text = shared[key];
    if (typeof text !== 'string') return key;
    if (!vars) return text;
    return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      return vars[name] != null ? String(vars[name]) : '';
    });
  }

  var SPINNER_HTML =
    '<div class="support-form-upload-spinner" role="status" aria-label="' +
    t('aria_uploading') +
    '"></div>';
  var CHECK_HTML =
    '<svg class="dy:mx-auto dy:h-16 dy:w-16 dy:text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>' +
    '</svg>';

  function ensureStyles() {
    var css =
      '.support-form-upload-spinner{width:64px;height:64px;margin:0 auto;border:4px solid #e5e7eb;border-top-color:#21334a;border-radius:50%;animation:support-form-upload-spin .8s linear infinite}' +
      '@keyframes support-form-upload-spin{to{transform:rotate(360deg)}}' +
      '.support-form-upload-track{width:100%;height:8px;background:#e5e7eb;border-radius:9999px;overflow:hidden;margin-bottom:12px}' +
      '.support-form-upload-fill{height:100%;width:0;background:#21334a;border-radius:9999px;transition:width .25s ease}' +
      '.support-form-upload-fill.is-active{background:linear-gradient(90deg,#21334a 0%,#4a6d8c 45%,#21334a 100%);background-size:200% 100%;animation:support-form-upload-sheen 1.1s linear infinite}' +
      '@keyframes support-form-upload-sheen{to{background-position:-200% 0}}' +
      '.support-form-upload-ready{color:#166534}';
    var existing = document.getElementById(STYLE_ID);
    if (existing) {
      existing.textContent = css;
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function yieldToUi() {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        window.setTimeout(resolve, 0);
      });
    });
  }

  function formatProgressLabel(text, pct) {
    var base = (text || '').replace(/\s*\(\d+%\)\s*$/, '').trim();
    if (!base) return '';
    if (pct >= 100) return base;
    return base + ' (' + pct + '%)';
  }

  function formatMb(bytes) {
    return (bytes / MB).toFixed(1);
  }

  function clampPct(value) {
    return Math.max(0, Math.min(100, Math.round(value)));
  }

  function validateFileSizes(files, maxBytes) {
    var list = files ? Array.from(files) : [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].size > maxBytes) {
        return {
          ok: false,
          message: t('file_too_large', {
            filename: list[i].name,
            size: formatMb(list[i].size),
            max: formatMb(maxBytes),
          }),
        };
      }
    }
    return { ok: true, message: '' };
  }

  function readFileAsInt8(file, onProgress) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      // FileReader usually jumps 0 → 100 locally with no intermediates.
      // Always drive a short synthetic ramp so the bar visibly moves.
      var fakePct = 0.05;
      var startedAt = Date.now();
      var minVisibleMs = 360;
      var resultBytes = null;
      var readError = null;
      var settled = false;

      if (onProgress) onProgress(fakePct);

      function finishOk() {
        if (settled) return;
        settled = true;
        window.clearInterval(timer);
        if (onProgress) onProgress(1);
        resolve(resultBytes);
      }

      function finishErr() {
        if (settled) return;
        settled = true;
        window.clearInterval(timer);
        reject(readError);
      }

      var timer = window.setInterval(function () {
        if (fakePct < 0.9) {
          fakePct = Math.min(0.9, fakePct + 0.08);
          if (onProgress) onProgress(fakePct);
        }
        if (readError) {
          finishErr();
          return;
        }
        // Hold until the ramp has been visible, even if the read already finished.
        if (resultBytes !== null && Date.now() - startedAt >= minVisibleMs) {
          finishOk();
        }
      }, 40);

      reader.onload = function () {
        resultBytes = Array.from(new Int8Array(reader.result));
        if (Date.now() - startedAt >= minVisibleMs) {
          finishOk();
        }
      };
      reader.onerror = function () {
        readError = new Error(t('could_not_read', { filename: file.name }));
        finishErr();
      };
      reader.readAsArrayBuffer(file);
    });
  }

  function readFilesWithProgress(files, onProgress) {
    var list = files ? Array.from(files) : [];
    if (!list.length) {
      if (onProgress) onProgress(1, t('preparing_request'));
      return Promise.resolve([]);
    }

    var payload = [];
    var index = 0;

    function readNext() {
      if (index >= list.length) return Promise.resolve(payload);
      var file = list[index];
      var current = index;
      var label = t('preparing_file_of', { current: current + 1, total: list.length });
      if (onProgress) onProgress(current / list.length, label);
      return readFileAsInt8(file, function (filePct) {
        var overall = (current + filePct) / list.length;
        if (onProgress) onProgress(overall, label);
      }).then(function (data) {
        payload.push({
          filename: file.name,
          mimeType: file.type || 'application/octet-stream',
          data: data,
        });
        index += 1;
        return readNext();
      });
    }

    return readNext();
  }

  function postToMailer(url, formData) {
    // Apps Script mailer emails the submission to Zendesk via MailApp.
    // Form-urlencoded body keeps this a "simple" CORS request (no preflight).
    var params = new URLSearchParams();
    ['name', 'email', 'phone', 'subject', 'body'].forEach(function (key) {
      params.append(key, String(formData.get('contact[' + key + ']') || ''));
    });
    params.append('page', window.location.href);

    return fetch(url, { method: 'POST', body: params })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.ok) return { ok: true };
        console.error('[SupportForm] Mailer did not send:', data && data.error);
        return { ok: false, reason: 'mailer_error' };
      })
      .catch(function (err) {
        console.error('[SupportForm] Mailer request failed:', err);
        return { ok: false, reason: 'network_error' };
      });
  }

  function postContactForm(formData) {
    // Shopify /contact emails the store contact address, which creates the Zendesk ticket.
    // Success redirects to ?contact_posted=true; a CAPTCHA block redirects to /challenge.
    // Stores where /contact requires CAPTCHA (EU: 400 "Missing CAPTCHA token") set the
    // "Mailer Apps Script URL" theme setting instead.
    // Never throws: the request is already saved to the Google Sheet at this point.
    var mailerUrl = (window.SupportFormConfig && window.SupportFormConfig.mailerUrl) || '';
    if (mailerUrl) return postToMailer(mailerUrl, formData);

    return fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) {
        var url = res.url || '';
        if (res.ok && url.indexOf('contact_posted=true') !== -1) return { ok: true };
        var reason = url.indexOf('/challenge') !== -1 ? 'captcha_challenge' : 'status_' + res.status;
        console.error('[SupportForm] Shopify contact form not posted:', reason, url);
        return { ok: false, reason: reason };
      })
      .catch(function (err) {
        console.error('[SupportForm] Shopify contact form request failed:', err);
        return { ok: false, reason: 'network_error' };
      });
  }

  function toQueryString(query) {
    if (query instanceof URLSearchParams) return query.toString();
    return new URLSearchParams(query || {}).toString();
  }

  function uploadToGoogleSheet(options) {
    var url = options.url;
    var query = options.query;
    var filesPayload = options.filesPayload || [];
    var onProgress = options.onProgress;
    var pct = 0.1;
    var timer;
    var keepOpen = t('uploading_keep_open');
    var packing = t('packing_files');

    function report(value, label) {
      if (onProgress) onProgress(value, label);
    }

    // Paint "packing" first — JSON.stringify of large files can block the main thread.
    report(0.04, packing);

    return yieldToUi()
      .then(function () {
        var body = JSON.stringify({ files: filesPayload });
        report(0.12, keepOpen);
        return body;
      })
      .then(function (body) {
        return yieldToUi().then(function () {
          return body;
        });
      })
      .then(function (body) {
        // Real upload % isn't available via fetch + GAS. Keep the bar creeping
        // toward ~97% the whole time the request is in flight so it never looks stuck.
        var startedAt = Date.now();
        timer = window.setInterval(function () {
          pct = Math.min(0.97, pct + Math.max(0.004, (0.97 - pct) * 0.035));
          var elapsedSec = Math.floor((Date.now() - startedAt) / 1000);
          var label =
            elapsedSec >= 5 ? t('uploading_still_working', { seconds: elapsedSec }) : keepOpen;
          report(pct, label);
        }, 250);

        return fetch(url + '?' + toQueryString(query), {
          method: 'POST',
          body: body,
        });
      })
      .then(function (res) {
        return res.json().then(
          function (data) {
            if (data && data.ok) {
              report(1, t('upload_complete'));
              return data;
            }
            throw new Error((data && data.error) || t('upload_failed'));
          },
          function () {
            throw new Error(t('unexpected_response'));
          }
        );
      })
      .catch(function (err) {
        if (err && err.message && err.message !== 'Failed to fetch') throw err;
        throw new Error(t('network_error'));
      })
      .finally(function () {
        window.clearInterval(timer);
      });
  }

  function createFilePrepController() {
    var generation = 0;
    var currentPromise = Promise.resolve([]);
    var ready = true;

    return {
      isReady: function () {
        return ready;
      },
      reset: function () {
        generation += 1;
        ready = true;
        currentPromise = Promise.resolve([]);
      },
      prepare: function (files, onProgress) {
        var list = files ? Array.from(files) : [];
        var myGen = (generation += 1);
        if (!list.length) {
          ready = true;
          currentPromise = Promise.resolve([]);
          if (onProgress) onProgress(1, t('no_files_to_prepare'));
          return currentPromise;
        }
        ready = false;
        currentPromise = readFilesWithProgress(list, onProgress).then(
          function (payload) {
            if (myGen !== generation) return [];
            ready = true;
            return payload;
          },
          function (err) {
            if (myGen !== generation) return [];
            ready = false;
            throw err;
          }
        );
        return currentPromise;
      },
      getPayload: function () {
        return currentPromise;
      },
    };
  }

  function bindInlineProgress(root) {
    ensureStyles();
    if (!root) {
      return {
        setProgress: function () {},
        setReady: function () {},
        setError: function () {},
        hide: function () {},
      };
    }

    root.innerHTML =
      '<div data-inline-progress>' +
      '<div class="support-form-upload-track"><div class="support-form-upload-fill" data-upload-bar></div></div>' +
      '<p class="dy:body-sm dy:text-gray-600" data-upload-label></p>' +
      '</div>';

    var bar = root.querySelector('[data-upload-bar]');
    var label = root.querySelector('[data-upload-label]');

    return {
      setProgress: function (pct, text) {
        var n = clampPct(pct);
        root.classList.remove('dy:hidden');
        if (bar) {
          bar.style.width = n + '%';
          bar.classList.toggle('is-active', n > 0 && n < 100);
        }
        if (label) {
          label.className = 'dy:body-sm dy:text-gray-600';
          label.textContent = formatProgressLabel(text, n);
        }
      },
      setReady: function (text) {
        root.classList.remove('dy:hidden');
        if (bar) {
          bar.style.width = '100%';
          bar.classList.remove('is-active');
        }
        if (label) {
          label.className = 'dy:body-sm support-form-upload-ready';
          label.textContent = text || t('files_ready');
        }
      },
      setError: function (message) {
        root.classList.remove('dy:hidden');
        if (bar) {
          bar.style.width = '0%';
          bar.classList.remove('is-active');
        }
        if (label) {
          label.className = 'dy:body-sm dy:text-red-500';
          label.textContent = message || '';
        }
      },
      hide: function () {
        root.classList.add('dy:hidden');
        root.innerHTML = '';
      },
    };
  }

  function bindPanel(root) {
    ensureStyles();
    if (!root) {
      return {
        reset: function () {},
        setProgress: function () {},
        setSuccess: function () {},
        setError: function () {},
      };
    }

    var icon = root.querySelector('[data-upload-icon]');
    var title = root.querySelector('[data-upload-title]');
    var progressWrap = root.querySelector('[data-upload-progress]');
    var bar = root.querySelector('[data-upload-bar]');
    var label = root.querySelector('[data-upload-label]');
    var status = root.querySelector('[data-upload-status]');

    function showProgress(visible) {
      if (!progressWrap) return;
      if (visible) progressWrap.classList.remove('dy:hidden');
      else progressWrap.classList.add('dy:hidden');
    }

    return {
      reset: function () {
        if (icon) icon.innerHTML = SPINNER_HTML;
        if (title) title.textContent = t('submitting_title');
        if (bar) {
          bar.style.width = '0%';
          bar.classList.remove('is-active');
        }
        if (label) label.textContent = '';
        if (status) status.innerHTML = '';
        showProgress(true);
      },
      setProgress: function (pct, text) {
        var n = clampPct(pct);
        if (icon) icon.innerHTML = SPINNER_HTML;
        if (title) title.textContent = t('submitting_title');
        if (bar) {
          // Never leave the bar visually empty once upload has started.
          bar.style.width = (n > 0 && n < 8 ? 8 : n) + '%';
          bar.classList.toggle('is-active', n > 0 && n < 100);
        }
        if (label) label.textContent = formatProgressLabel(text, n);
        showProgress(true);
      },
      setSuccess: function (html) {
        if (icon) icon.innerHTML = CHECK_HTML;
        if (title) title.textContent = t('thank_you');
        if (bar) bar.classList.remove('is-active');
        if (label) label.textContent = '';
        if (status) status.innerHTML = html;
        showProgress(false);
      },
      setError: function (message) {
        if (bar) bar.classList.remove('is-active');
        if (status) {
          status.innerHTML = '<p class="dy:text-red-500 dy:mb-6">' + message + '</p>';
        }
      },
    };
  }

  function setButtonsDisabled(buttons, disabled) {
    (buttons || []).forEach(function (button) {
      if (!button) return;
      button.disabled = !!disabled;
      button.setAttribute('aria-busy', disabled ? 'true' : 'false');
      button.classList.toggle('dy:opacity-50', !!disabled);
      button.classList.toggle('dy:pointer-events-none', !!disabled);
    });
  }

  function onBeforeUnload(event) {
    event.preventDefault();
    event.returnValue = '';
  }

  function setUnloadGuard(active) {
    if (active) {
      window.addEventListener('beforeunload', onBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', onBeforeUnload);
    }
  }

  window.SupportFormUpload = {
    MB: MB,
    MAX_IMAGE_BYTES: 10 * MB,
    MAX_MEDIA_BYTES: 100 * MB,
    t: t,
    validateFileSizes: validateFileSizes,
    readFilesWithProgress: readFilesWithProgress,
    postContactForm: postContactForm,
    uploadToGoogleSheet: uploadToGoogleSheet,
    createFilePrepController: createFilePrepController,
    bindInlineProgress: bindInlineProgress,
    bindPanel: bindPanel,
    setButtonsDisabled: setButtonsDisabled,
    setUnloadGuard: setUnloadGuard,
  };
})(window);
